import { arrayOf, bool, number, object, oneOfType, shape, string } from "prop-types";
import { observer } from "mobx-react";
import { Controller } from "react-hook-form";
import { Radio } from "@components";
import { Grid } from "@material-ui/core";
import classNames from "classnames";

export const ControlledRadioGroup = observer(({
  control,
  name,
  options,
}) => {

  return (
    <Controller
      name={name}
      control={control}
      render={({
        field: { onChange, value: controllerValue, name },
        fieldState: { error },
      }) => (
        <Grid item container direction="column" wrap="nowrap">
          {
            options.map(({ value, label }) => (
              <Radio
                key={value}
                name={name}
                error={!!error}
                value={value}
                checked={value.toString() === controllerValue.toString()}
                onChange={onChange}
                label={label}
                className={classNames("my-1")}
              />
            ))
          }
          {!!error && (
            <span className="mt-2 color-error">{error?.message}</span>
          )}
        </Grid>
      )}
    />
  );
});

ControlledRadioGroup.propTypes = {
  control: object.isRequired,
  name: string.isRequired,
  options: arrayOf(shape({
    value: oneOfType([number, string, bool]).isRequired,
    label: string.isRequired,
  })).isRequired,
};
